<template>
  <v-toolbar color="primary">
    <v-btn text :to="homeLink">
      <v-icon>home</v-icon>
    </v-btn>
    <v-spacer></v-spacer>
    <img class="logo" src="/api/logo">
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <v-btn :class="{hidden: ! hasImages}" text to="/basket">
        <v-badge overlap bottom color="red">
          <template v-slot:badge color="white">{{ basketBadge }}</template>
          <v-icon>shopping_cart</v-icon>
        </v-badge>
      </v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";

@Component({
  components: {}
})
export default class ToolBar extends BasicComponent {

  get basketBadge() {
    return this.$store.getters.basketBadge;
  }

  get homeLink() {
    const step = this.$store.getters.step || String(this.$route.query.step);
    if (! step) {
      return "/";
    }
    return {name: "home", query: {step: step}};
  }

}

</script>
<style lang="scss" scoped>

.logo {
  max-height: 90%;
  height: auto !important;
  max-width: 100% !important;
  margin-top: 5px;

  @media screen and (max-width: 375px) {
    max-width: calc(100% - (2 * 88px)) !important;
  }
}

.v-toolbar {
  flex: 0 1 auto;
}

.md-primary {
  position: fixed;
  top: 0;
  z-index: 100;
}

</style>
<style lang="scss">

.hidden {
  visibility: hidden;
}

.md-menu-content {
}

.basket_icon, .home_icon {
  color: white !important;
}

.basketBadge {

  .md-badge {
    margin-right: 15px;
    margin-bottom: 5px;
  }
}
</style>
